import React from 'react';
import { Rect, Text, Image } from 'react-konva';
import {
  isMobilePhone,
} from '../../../library/calc';


export const TreematchBox = ({
    fn,
    n,
    g,
    pid,
    left,
    top,
    focus,
    // stopStageClickPropagation,
    p,
    updated,
    nn,
    yCoord4Matchbox,
    width4Matchbox,
    leftStart4Boxes,
    paddingBetweenBoxes,
    matchBoxHeight,
    tm,
    // pr_id,
    onTouchMatch,
    matchesColors,
    // cursorBecomesMove,
    // cursorBecomesPointer,
  }) => {

  tm = (typeof(tm) !== 'undefined' ? parseInt(tm, 10 ): 0 );
  left += leftStart4Boxes;
  top += yCoord4Matchbox;

  // const prId = pr_id;
  // const href = `/search/matches?id=${prId}&src=canvas-tree&cmp=btn`;

  return <Rect
    x={left}
    y={top}
    width={width4Matchbox}
    height={matchBoxHeight}
    cursor="pointer"
    fill={( tm === 0 ? matchesColors.empty : matchesColors.tree)}
    cornerRadius={0}

    // onTouchStart={()=>{
    //   stopStageClickPropagation({fromWhere:'tm - A'})
    //   if(tm > 0) onTouchMatch(href);
    // }}


    // onClick={()=> {
    //   if(isMobilePhone() ) return;
    //   stopStageClickPropagation({fromWhere:'tm - B'});
    //   if(tm > 0){console.log('opening window F'); window.open(href, '_blank');window.safari.self.browserWindow.openTab();}
    //   else {console.log('tree match - n', n)}
    // }}

    // onMouseenter={()=>{
    //   if(tm > 0) cursorBecomesPointer();
    // }}

    // onMouseleave={()=>{
    //   cursorBecomesMove();
    // }}
  />;
};

export const TmLabel = ({
    tm,
    // pr_id,
    onTouchMatch,
    left,
    top,
    leftStart4Boxes,
    topMatchLabel,
    leftStart4MatchLabel,
    fontSizeMatchCount,
    fontFamilyMatchLabel,
    textWidth,
    n,
    stopStageClickPropagation,
    cursorBecomesMove,
    cursorBecomesPointer,
  }) => {

    tm = (typeof(tm) !== 'undefined' ? parseInt(tm, 10 ): 0 );
    left += leftStart4Boxes;
    left += leftStart4MatchLabel;
    top += topMatchLabel;

    const textIs = (tm < 100 ? tm.toString(): '99+');

    // const prId = pr_id;
    // const href = `/search/matches?id=${prId}&src=canvas-tree&cmp=btn`;

    return <Text

      // onTouchStart={()=>{
      //   stopStageClickPropagation({fromWhere:'tm - C'});
      //   if(tm > 0) onTouchMatch(href);
      // }}

      // onClick={()=> {
      //   if(isMobilePhone() ) return;
      //   stopStageClickPropagation({fromWhere:'tm - D'});
      //   if(tm > 0){console.log('opening window D'); window.open(href, '_blank');window.safari.self.browserWindow.openTab();}
      //   else {console.log('tree match - n', n)}
      // }}

      x={left}
      y={top}
      text={`${textIs}`}
      fontSize={fontSizeMatchCount}
      fontFamily={fontFamilyMatchLabel}
      fill='white'
      align='center'
      width={textWidth}
      // onMouseenter={()=>{
      //   if(tm > 0) cursorBecomesPointer();
      // }}
      // onMouseleave={()=>{
      //   cursorBecomesMove();
      // }}
    />;
  };

export class TreeMatchIcon extends React.Component {

    render() {

      let {
        // tm,
        left,
        top,
        leftStart4Boxes,
        topMatchLabel,
        leftMargin,
        iconWidth,
        geniImg,
        // pr_id,
        // onTouchMatch,
        // n,
        // stopStageClickPropagation,
        // cursorBecomesMove,
        // cursorBecomesPointer,
      } = this.props;

      left += leftStart4Boxes + leftMargin;
      top += topMatchLabel - .2;

      const dim = iconWidth;

      // const prId = pr_id;
      // const href = `/search/matches?id=${prId}&src=canvas-tree&cmp=btn`;

      return (
          <Image

            // onTouchStart={()=>{
            //   stopStageClickPropagation({fromWhere:'tm - E'});
            //   if(tm > 0) onTouchMatch(href);
            // }}

            // onClick={()=> {
            //   if(isMobilePhone() ) return;
            //   stopStageClickPropagation({fromWhere:'tm - F'});
            //   if(tm > 0){console.log('opening window B'); window.open(href, '_blank');window.safari.self.browserWindow.openTab();}
            //   else {console.log('tree match - n', n)}
            // }}

            image={geniImg}
            scaleX={.1}
            scaleY={.1}
            width={dim * 10}
            height={dim * 10}
            x={left}
            y={top}
            // onMouseenter={()=>{
            //   if(tm > 0) cursorBecomesPointer();
            // }}
            // onMouseleave={()=>{
            //   cursorBecomesMove();
            // }}
          />
      );
    }
}


export const TreematchTransparentEventBox = ({
    fn,
    n,
    g,
    pid,
    left,
    top,
    focus,
    stopStageClickPropagation,
    p,
    updated,
    nn,
    yCoord4Matchbox,
    width4Matchbox,
    leftStart4Boxes,
    paddingBetweenBoxes,
    matchBoxHeight,
    tm,
    pr_id,
    onTouchMatch,
    matchesColors,
    cursorBecomesMove,
    cursorBecomesPointer,
    fillMatchBubbleContent,
    matchBubbleContent,
  }) => {

  tm = (typeof(tm) !== 'undefined' ? parseInt(tm, 10 ): 0 );
  left += leftStart4Boxes;
  top += yCoord4Matchbox;

  const prId = pr_id;
  const href = `/search/matches?id=${prId}&src=canvas-tree&cmp=btn`;

  return <Rect
    x={left}
    y={top}
    width={width4Matchbox}
    height={matchBoxHeight}
    cursor="pointer"
    fill={( tm === 0 ? matchesColors.empty : matchesColors.tree)}
    cornerRadius={0}
    opacity={0}

    onTouchStart={()=>{
      stopStageClickPropagation({fromWhere:'tm - A'})
      if(tm > 0) onTouchMatch(href);
    }}

    onClick={()=> {
      if(isMobilePhone() ) return;
      stopStageClickPropagation({fromWhere:'tm - B'});
      if(tm > 0){
        console.log('opening window F');
        window.open(href, '_blank');
        // if( typeof(window.safari) !== 'undefined' ) window.safari.self.browserWindow.openTab(); -- Depreciated Safari
      }
      else {console.log('tree match - n', n)}
    }}

    onMouseenter={()=>{
      if(typeof(matchBubbleContent) === 'undefined') fillMatchBubbleContent({matchBubbleContent: `{count} pending Tree Matches`, matchBubbleContentVarStr: tm});
      if(tm > 0) cursorBecomesPointer();
    }}
    onMouseleave={()=>{
      cursorBecomesMove();
      if(typeof(matchBubbleContent) !== 'undefined') fillMatchBubbleContent({matchBubbleContent: undefined, matchBubbleContentVarStr: undefined});
    }}
  />;
};
